<div id="banner-background" class="min-height-250 position-absolute w-100 banner-background"></div>
<main class="main-content position-relative border-radius-lg min-height-250">
  <div class="container pt-4">
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
<footer class="pt-4">
  <app-footer></app-footer>
</footer>
